module.exports = __webpack_public_path__ + "static/img/3.86bb8e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.png
// module id = LHqX
// module chunks = 13